import { useState } from 'react';

export const useSliderRange = ({
	currentValues,
	min,
	max,
}: {
	currentValues?: [number, number];
	min: number;
	max: number;
}) => {
	const [value, setValue] = useState<[number, number]>(
		currentValues ?? [min, max]
	);

	return {
		value,
		setValue,
		min,
		max,
	};
};
